import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import * as React from "react";

export default function OwnerGroup({ handleSelection, selectedValue, options, sx }) {
  return(
    <>
      { options && options.length>0 && (
        <Select
          defaultValue={ options[0].id }
          value={selectedValue}
          onChange={ handleSelection }
          displayEmpty={ true }
          inputProps={ { "aria-label": "Without label" } }
          sx={{ width: 384, height: 40, m: 2, ...sx }}
        >
          { options.map((item) => (
            <MenuItem key={ item.id } value={ item.id }>{ item.id }</MenuItem>
          )) }
        </Select>
      ) }
    </>
  );
}
